export class AnticipatorEvents {
    public static readonly ANIMATION_STARTED: symbol = Symbol('ANIMATION_STARTED');
    public static readonly ANTICIPATION_REELS_RESULT_RECEIVED: symbol = Symbol('ANTICIPATION_REELS_RESULT_RECEIVED');
}